import { adminHttpClient } from './adminHttpClient'

const callGetApi = (fileUrl: string): Promise<string> => {
  return adminHttpClient.get(fileUrl)
}

export default callGetApi
